import React from "react";
import { Link } from "react-router-dom";
import { Home, Sparkles, ShieldCheck, Check, ArrowRight } from "lucide-react";
import HostApplicationForm from "../components/HostApplicationForm";

const PILLARS = [
  { title: "Predictable income", desc: "Janté pays you 1.5% of rental rates as a steady monthly lease — you don't chase bookings." },
  { title: "We operate under our license", desc: "Your STR license stays yours; we lease the property and operate it on our network." },
  { title: "Zero operational lift", desc: "No guest messaging, no cleanings, no reviews to wrangle. You collect. We hustle." },
  { title: "Long-term partnership", desc: "Eligibility reviewed annually. Rate adjustments matched to the market." },
];

export default function RentalToRentPage() {
  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-12 py-16" data-testid="r2r-page">
      <Link to="/hosts" className="btn-ghost inline-flex mb-6">← All hosts</Link>

      <div className="grid lg:grid-cols-[1.3fr_1fr] gap-10 items-end">
        <div>
          <div className="overline"><span className="text-[var(--brand-red)]">Rental-to-Rent</span> · For STR-licensed landlords</div>
          <h1 className="font-display text-5xl sm:text-6xl text-[var(--emerald)] mt-5 leading-[1.05]">
            We lease. You earn.<br />
            <em className="not-italic text-[var(--gold)]">No guests, no turnover.</em>
          </h1>
          <p className="text-[var(--ink-2)] mt-5 max-w-xl">
            Janté leases eligible, STR-licensed properties directly from you and pays <strong className="text-[var(--emerald)]">1.5% of rental rates</strong> as a steady monthly income stream. You stay the landlord; we do the operating.
          </p>
          <div className="mt-5 inline-flex items-center gap-3 px-4 py-2 border border-[var(--gold)] text-[var(--emerald)] text-sm">
            <Home size={15} strokeWidth={1.5} className="text-[var(--gold)]" />
            <span>1.5% rental-rate pay-through · Zero operational lift</span>
          </div>
        </div>
        <div className="lux-card-dark">
          <Sparkles size={20} strokeWidth={1.25} className="text-[var(--gold)]" />
          <div className="overline text-[var(--gold)] mt-3">Eligibility</div>
          <ul className="mt-3 space-y-1.5 text-sm opacity-95">
            <li>· Valid STR license (current or in-process)</li>
            <li>· Property in a Janté-active market</li>
            <li>· Minimum 12-month lease term</li>
            <li>· Property insurance in place</li>
          </ul>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 gap-5 mt-14">
        {PILLARS.map((p) => (
          <div key={p.title} className="lux-card">
            <Check size={16} strokeWidth={1.5} className="text-[var(--gold)]" />
            <h3 className="font-display text-2xl text-[var(--emerald)] mt-3">{p.title}</h3>
            <p className="text-sm text-[var(--ink-2)] mt-2">{p.desc}</p>
          </div>
        ))}
      </div>

      <div className="mt-16">
        <div className="overline">Apply</div>
        <h2 className="font-display text-4xl text-[var(--emerald)] mt-2">
          Check your eligibility.
        </h2>
        <HostApplicationForm
          program="rental_to_rent"
          title="Rental-to-Rent application"
          cta="Apply — Rental-to-Rent"
        />
      </div>

      <div className="mt-10 flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-[var(--muted)]">
        <ShieldCheck size={12} strokeWidth={1.25} className="text-[var(--gold)]" />
        Eligibility confirmed within 5 business days. Rate locked for 12 months.
      </div>
    </div>
  );
}
